import api from "@/api";

const state = {
    list: [],
};

const getters = {
    list(state) {
        return state.list;
    },
};

const actions = {
    getList({ commit }) {
        return api.get("/api/checkins/templates").then(response => {
            commit("updateList", {
                list: response.data.items,
            });
        });
    },
    upsert({ dispatch }, { payload: data }) {
        return api.put(`/api/checkins/templates/${data._id}`, data).then(() => {
            dispatch({ type: "getList" });
        });
    },
    delete({ dispatch }, { payload: { templateId } }) {
        return api.delete(`/api/checkins/templates/${templateId}`).then(() => {
            dispatch({ type: "getList" });
        });
    },
};

const mutations = {
    updateList(state, { list }) {
        state.list = [...list];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
